import { SET_SIDEBAR_CLICK } from './sidebar.type';

export const setSidebarClick = (linkClick) => {
  return {
    type: SET_SIDEBAR_CLICK,
    payload: linkClick
  };
};
